import 'core-js/es/symbol/dispose.js'

import { DBObjectStore } from './db-object-store.js'
import type { DatabaseSchema } from './schema.js'

export class DBTransaction<
  Schema extends DatabaseSchema,
> implements Disposable {
  #tx: IDBTransaction | null

  constructor(tx: IDBTransaction) {
    this.#tx = tx

    const onAbort = () => {
      cleanup()
    }
    const onComplete = () => {
      cleanup()
    }
    const cleanup = () => {
      this.#tx = null
      tx.removeEventListener('abort', onAbort)
      tx.removeEventListener('complete', onComplete)
    }
    tx.addEventListener('abort', onAbort)
    tx.addEventListener('complete', onComplete)
  }

  protected get tx(): IDBTransaction {
    if (!this.#tx) throw new Error('Transaction already ended')
    return this.#tx
  }

  async abort() {
    const { tx } = this
    this.#tx = null
    tx.abort()
  }

  async commit() {
    const { tx } = this
    this.#tx = null
    tx.commit?.()
  }

  objectStore<T extends keyof Schema & string>(name: T) {
    const store = this.tx.objectStore(name)
    return new DBObjectStore<Schema[T]>(store)
  }

  [Symbol.dispose](): void {
    if (this.#tx) this.commit()
  }
}
